// packages/web/src/api/workorders/keys.ts

export const workordersKeys = {
  all: ["workorders"] as const,
  search: (q: string) => [...workordersKeys.all, "search", { q }] as const,
  cranesByWorkorder: (id: string) => [...workordersKeys.all, id, "cranes"] as const,
};
